<p>delete-dialog works!</p>
